import React from 'react';
import { Button } from '@cityelectricalfactors/ui-components';
import styled from 'styled-components';

const VideoPlaceholder = ({ images, icon, width, height, onClick }) => (
  <VideoBtn handleClick={onClick}>
    <img src={icon} className="video-placeholder__icon" alt="" />
    <picture>
      <source
        srcSet={images.avif}
        type="image/avif"
        width={width}
        height={height}
      />
      <source
        srcSet={images.webp}
        type="image/webp"
        width={width}
        height={height}
      />
      <img
        src={images.jpeg}
        className="width-100"
        alt=""
        width={width}
        height={height}
      />
    </picture>
  </VideoBtn>
);

const VideoBtn = styled(Button)`
  padding: 0;
`;

export default VideoPlaceholder;
